import { createDrawerStore } from '../drawer/createDrawerStore';

/**
 * Stack-based Zustand store for the bilateral `AccountTransaction`
 * drawer. Mirrors `useTransactionDrawerStore` but writes against
 * the new bilateral collection.
 */
export const useAccountTransactionDrawerStore = createDrawerStore();
